import styled from 'styled-components';
import { media, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const PortfolioReportWrapper = styled.article`
  ${media.mdUp`
		> section {
			padding: ${({ theme }) => `${theme.x4spacePx}px ${theme.x4spacePx}px`};
			padding-left: 0;
		}
	`};
`;

export const Provider = styled.div`
  padding: 8px;
  text-align: center;
  background: #172129;
  > img {
    max-height: 25px;
    vertical-align: middle;
    margin-left: 4px;
  }
`;

export const SectionWrapper = styled('div')`
  position: relative;
`;

export const HeaderControls = styled('div')`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
`;

export const Feedback = styled(Grid)`
  margin: ${({ theme }) => theme.x1spacePx}px;
  background: ${({ theme }) => theme.color.noir};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdUp`
    margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  `}
  ${media.lgUp`
    transform: translateY(-${({ theme }) => theme.x1spacePx}px);
    margin-left: 0;
    margin-right: 0;
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
	`};
`;

export const FeedbackContent = styled('div')`
  ${({ theme }) => theme.typography.xSmall};
  margin-top: ${({ theme }) => theme.x1spacePx / 4}px;
  margin-bottom: ${({ theme }) => theme.x1spacePx / 4}px;
`;

export const BannerWrapper = styled('div')`
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
